import Layouts from "../../layout/layouts";
import { Table, Form, Row, Col, Button } from "antd";
import { DatePicker as DatePickerJalali, Calendar, JalaliLocaleListener } from "antd-jalali";
import fa_IR from "antd/lib/locale/fa_IR";
import styles from "./Transactions.module.scss";
import { useTranslation } from "react-i18next";
import { complexDigitToman, convertToGregorian, convertToJalaliWithTime, validateInput } from "../../../tools/tools";
import { useTenders } from "../../../tools/api";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { _adr } from "../../../address";

const Transactions = () => {
  const [t] = useTranslation("global");
  const { queryWalletByDate } = useTenders();
  const [frmSearch] = Form.useForm();
  const [isLoadingList, setIsLoadingList] = useState(false);
  const [bTable, setBTable] = useState([]);
  //state current page show Records
  const [currentPage, setCurrentPage] = useState(0);
  // state totalRecord
  const [totalRecord, setTotalRecord] = useState(0);

  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    const callServices = async () => {
      try {
        let valid = await frmSearch.validateFields();
        if (valid) {
          let value = {
            duringdate: frmSearch.getFieldValue("duringdate"),
          };

          handleSearch(value);
        }
      } catch (error) {
        console.error(error);
      }
    };
    if (isActive) {
      callServices();
    }
  }, [currentPage]);

  const handleSearch = async (value) => {
    try {
      setIsLoadingList(true);
      let payload = {
        wallettype: 1,
        dateto: convertToGregorian(value?.duringdate[1].format("YYYY-MM-DD"), "-", "-"),
        datefrom: convertToGregorian(value?.duringdate[0].format("YYYY-MM-DD"), "-", "-"),
        searchconfigmodel: {
          sort: "",
          filter: "",
          entriesperpage: 10,
          page: currentPage === 0 ? 0 : currentPage - 1,
          totalrowcount: 0,
        },
      };
      let response = await queryWalletByDate(payload);
      if (!response.HasError) {
        setIsActive(true);
        let retGen = response.Result.map((item, key) => ({
          key: key,
          type: item.stR_ChargeType,
          amount: <span dir="ltr">{complexDigitToman(item.inT_ChargeAmount)}</span>,
          datetime: convertToJalaliWithTime(item.dtE_OperationDate, "-"),
          // trackingcode: "-",
          credit: <span dir="ltr">{complexDigitToman(item.inT_WalletAmount)}</span>,
          status: item.stR_ChargeState,
          // action: (
          //   <>
          //     <Link to={_adr.Root + _adr.Landing.Index + _adr.Landing.Details + `?id=${item?.auctionProductId}`} state={{ state: { type: "1" } }}>
          //       جزئیات
          //     </Link>
          //   </>
          // ),
        }));
        setBTable(retGen);
        setTotalRecord(response?.searchconfigmodel?.totalrowcount);
      }
      setIsLoadingList(false);
    } catch (error) {
      console.error(error);
      setIsLoadingList(false);
    }
  };
  return (
    <>
      <div className="transaction_container">
        <div className="title">
          <h3>تراکنش ها</h3>
        </div>
        <Form id="frmSearch" form={frmSearch} onFinish={handleSearch} layout="vertical">
          <Row gutter={30}>
            <Col>
              <JalaliLocaleListener />
              <Form.Item name="duringdate" label="انتخاب تاریخ" rules={[validateInput({ t: t, validate: true, typeOfValue: "array" })]}>
                <DatePickerJalali.RangePicker format={"YYYY/MM/DD"} />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item label={<></>}>
                <div className="holder-button">
                  <Button form="frmSearch" key={frmSearch} htmlType="submit" className="btn-green">
                    جستجو
                  </Button>
                </div>
              </Form.Item>
            </Col>
          </Row>
        </Form>

        <div className="holder_table">
          <Table
            columns={[
              {
                title: "نوع تراکنش",
                dataIndex: "type",
                key: "type",
                width: 150,
              },
              {
                title: "مبلغ",
                dataIndex: "amount",
                key: "amount",
                width: 150,
              },
              {
                title: "تاریخ و ساعت",
                dataIndex: "datetime",
                key: "datetime",
                width: 150,
              },
              // {
              //   title: "شماره ارجاع بانک",
              //   dataIndex: "trackingcode",
              //   key: "trackingcode",
              // },
              {
                title: "مانده اعتبار",
                dataIndex: "credit",
                key: "credit",
                width: 150,
              },
              {
                title: "وضعیت",
                dataIndex: "status",
                key: "status",
                width: 150,
              },
              // {
              //   title: "",
              //   dataIndex: "action",
              //   key: "action",
              // },
            ]}
            pagination={{
              className: "page-pagination",
              // position: [totalRecord.length > 10 ? "bottomLeft" : "none"],
              onChange: (page) => {
                setCurrentPage(page);
              },
              pageSize: 10,
              align: "start",
              current: currentPage === 0 ? 1 : currentPage,
              total: totalRecord,
              showSizeChanger: false,
            }}
            scroll={{ y: 240 }}
            loading={isLoadingList}
            dataSource={bTable}
          ></Table>
        </div>
      </div>
    </>
  );
};

export default Transactions;
